// extracted by mini-css-extract-plugin
module.exports = {"loading_3fKetC":"loading_3fKetC","small_RdLdVC":"small_RdLdVC","medium_1J8VYf":"medium_1J8VYf","spinner_Hy2s0q":"spinner_Hy2s0q"};